const { showError } = require('../libs/helper');
var qs = require('qs');

module.exports = {
  submit: async (g, data) => {
    await g.$http({
      url: process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna/store-data-informasi',
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403)
            showNotifikasi(g, 'danger', 'Error Submit Form', res.data.message)
          else
            g.$router.push({ name: 'dataInformasi' })
        } catch (error) {
          g.$router.push({ name: 'dataInformasi' })
        }
      })
      .catch(err => {
        showError(g, err, `Error Submit Form`)
      })
  },
  validasi: async (g, data, redirectName = 'dataInformasi', isRedirect = true) => {
    await g.$http({
      url: process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna/store-validasi-data-informasi',
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    })
      .then(res => {
        if (isRedirect)
          g.$router.push({ name: redirectName })
      })
      .catch(err => {
        showError(g, err, `Error Submit Form`)
      })
  },
}